import { AuthService } from "@/services";
import { ILayoutImage } from "../layout-editor";
import { SaleLayoutLogoPosition } from "./logo";
import { CustomTranslation } from "../custom-translation";

export type PaymentQrReferenceType = "Ogm" | "SaleNumber" | "Custom";

export class PaymentQrSettings implements ILayoutImage{
	Width:number = 50;
	Height:number = 50;
	X:number = 50;
	Y:number = 50;
	Show:boolean = false;
	Placement:SaleLayoutLogoPosition = "Heading"
	BankID:number = 1;
	ReceipientName:string = AuthService.wfCompany.Name;
	ReferenceType:PaymentQrReferenceType = "Ogm";
	CustomReferenceText:CustomTranslation = new CustomTranslation();
	CustomReferenceProp:string = "";

	public constructor(data?:any) {
		if (!data) return;
		this.Width = data.Width || 20;
		this.Height = data.Height || 20;
		this.X = data.X;
		this.Y = data.Y;
		this.Show = data.Show;
		this.Placement = data.Placement;
		this.BankID = data.BankID || 1;
		this.ReceipientName = data.ReceipientName || "";
		this.ReferenceType = data.ReferenceType || "Ogm";
		this.CustomReferenceText = new CustomTranslation(data.CustomReferenceText);
		this.CustomReferenceProp = data.CustomReferenceProp || "";
	}

	public getJSON():any{
		return {
			Width: this.Width,
			Height: this.Height,
			X: this.X,
			Y: this.Y,
			Show: this.Show,
			Placement: this.Placement,
			BankID: this.BankID,
			ReceipientName: this.ReceipientName,
			ReferenceType: this.ReferenceType,
			CustomReferenceText: this.CustomReferenceText.getJSON(),
			CustomReferenceProp: this.CustomReferenceProp
		};
	}

	public getImageUrl(): string {
		return "/img/winfakt-be-qr.png";
	}
}
